import { LANGUAGE_DEFAULT } from '@app/modules/i18n-locales/i18n';
import { MasterCodeItem } from '@app/types/initScreen';
import { getCurrentLang } from '@app/utils/GetCurrentLang';
import { DropdownOption } from '../FormControl';

export function mapMasterCodeToDropdownOptions(masterCodeItems: MasterCodeItem[]): DropdownOption[] {
  const currentLang = getCurrentLang();
  const items: MasterCodeItem[] = masterCodeItems;

  if (!items) return [];
  return items.map((item) => ({
    label: currentLang === LANGUAGE_DEFAULT ? item.nameJA : item.nameEN,
    value: item.extensionCode1,
  }));
}
